import { QueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import _ from 'lodash';
import { Layout, MetaData, Footer } from '../components/shared';
import { parseTitle } from '../../utils/title-parser';
import { FadeInAnimation } from '../components/shared'
import { cmsService } from '../services/homii-services';

import SearchBar from '../components/search-bar/search-bar.component';
import CityCarousel from '../components/city-carousel/city-carousel.component';
import LazyFeaturedSpaces from '../components/featured-spaces/lazy-featured-spaces.component';

import cityDomain, { useSelectedCity } from '../domain/city/city.domain'

import StayOrStyleSection from '../components/find-a-space-components/stay-or-style-section.component';
import SpaceSection from '../components/find-a-space-components/space-section.component';
import ReviewSection from '../components/find-a-space-components/review-section.component';
import MobileAppSection from '../components/home-page-components/mobile-app-section.component';
import PromotionalModal from '../components/promotional-modal/promotional-modal.component';
import useResponsive  from '../../utils/responsive';

const Index = (props) => {

    const router = useRouter();
    const { isMobile } = useResponsive();
    const { data, baseUrlApp, promotionData } = props;
    const { data: selectedCity } = useSelectedCity(); 

    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroSubHeading = _.get(data, 'acf.hero_sub_heading');
    const citiesTitle = _.get(data, 'acf.city_title');
    const citiesParagraph = _.get(data, 'acf.city_paragraph');
    const reviews = _.get(data, 'acf.review');
    const stayOrStyleTitle = _.get(data, 'acf.style_section_title');
    const stayOrStyleParagraph = _.get(data, 'acf.style_section_paragraph');
    const spaceTitle = _.get(data, 'acf.space_section_title');
    const spaceParagraph = _.get(data, 'acf.space_section_paragraph');

    const mobileAppTitle = _.get(data, 'acf.mobile_title');
    const mobileAppParagraph = _.get(data, 'acf.mobile_paragraph');
    const mobileAppIcon = _.get(data, 'acf.mobile_icon.url');
    const mobileAppIconText = _.get(data, 'acf.mobile_icon_text');
    const mobilePrimaryImgSrc = _.get(data, 'acf.mobile_primary_image.url');
    const mobilePrimaryImgAlt = _.get(data, 'acf.mobile_primary_image_alt');
    const mobileAppSecondaryImgSrc = _.get(data, 'acf.mobile_secondary_image.url');
    const mobileAppSecondaryImgAlt = _.get(data, 'acf.mobile_secondary_image_alt');    

    const renderSearchBar = () => {
        const query = router.query;        
        return <SearchBar query={query} type={isMobile ? 'Mobile' : 'Bookings'} />;
    };    

    return(

        <Layout>

            <PromotionalModal promotionData={promotionData} />

            <MetaData title={seoTitle} desc={seoMetaDesc} canonical={`${baseUrlApp}/home`} />

            <div className='container-index container-root container-root-maxWidthLg'>

                {parseTitle(heroTitle, 'find_a_space_header', true)}

                <FadeInAnimation>
                    <div>
                        <p className='header-paragraph'>{heroSubHeading}</p>
                    </div>
                </FadeInAnimation> 

                {renderSearchBar()}
            
            </div>

            <div className='container-root container-root-maxWidthLg city-carousel-container city-carousel-container-calc'>
                <CityCarousel
                    title={citiesTitle}
                    paragraph={citiesParagraph}
                    type="FindaSpace"
                />
            </div>

            <div style={{ backgroundColor: '#243239' }}>
                <LazyFeaturedSpaces
                    title="Featured Spaces"
                    selectedCity={selectedCity}
                    isLanding={true}
                />
            </div>

            <div className='container-index container-root container-root-maxWidthLg'>
                <StayOrStyleSection title={stayOrStyleTitle} paragraph={stayOrStyleParagraph} />

                <SpaceSection title={spaceTitle} paragraph={spaceParagraph} />
            </div>

            <ReviewSection reviews={reviews} />

            <div className='corporate-container'>
                <MobileAppSection
                    title={mobileAppTitle}
                    paragraph={mobileAppParagraph}
                    icon={mobileAppIcon}
                    iconText={mobileAppIconText}
                    primaryImgSrc={mobilePrimaryImgSrc}
                    primaryImgAlt={mobilePrimaryImgAlt}
                    secondaryImgSrc={mobileAppSecondaryImgSrc}
                    secondaryImgAlt={mobileAppSecondaryImgAlt}
                />
            </div>

            <Footer />

        </Layout>

    )
};

export const getServerSideProps = async () => {
    const queryClient = new QueryClient();
    await queryClient.prefetchQuery({
        queryKey: ['cities'],
        queryFn: cityDomain.fetchAllCitiesData,
    });
    await queryClient.prefetchQuery({
        queryKey: ['selectedCity'],
        queryFn: cityDomain.fetchClosestCity,
    });
    const data = await cmsService.RetrieveWordPressPage('find-a-space');

    const desktopImageUrl = _.get(data, 'acf.promotion_desktop_background_image.url');
    const mobileImageUrl = _.get(data, 'acf.promotion_mobile_background_image.url');

    const promotionData = {
        promotion_start_date: _.get(data, 'acf.promotion_start_date', null),
        promotion_end_date: _.get(data, 'acf.promotion_end_date', null),       
        promotion_desktop_background_url: desktopImageUrl,
        promotion_mobile_background_url: mobileImageUrl,
        promotion_title: _.get(data, 'acf.promotion_title', null),
        promotion_text: _.get(data, 'acf.promotion_text', null),
    };

    return {
        props: {
            data,
            promotionData,
        }
    };
};

export default Index;

Index.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
    promotionData: PropTypes.object,
};

